class Locanda {

    constructor() {
        console.log('locanda js class initialized')
        this.events()
    }

    events() {
        document.addEventListener("DOMContentLoaded", e => this.inizializeObj());
    }

    inizializeObj() {
        if (document.querySelector("#logo_locanda") !== null) {
            window.addEventListener("scroll", e => this.windowScrollHandler(e))
        }
                
        // se c'è un errore di validazione del form prenota, scrollo fino al form
        const formValidationError = document.querySelector('.gform_validation_error');
        const targetForm = document.querySelector('#form_prenota_intro');
        if (formValidationError !== null && targetForm !== null) {
            setTimeout(() => {
                targetForm.scrollIntoView({behavior: "smooth", block: "end", inline: "end"});
            }, 100);
        }
    }

    windowScrollHandler(e) {
        let a, b, relativeTopPosition, stickyTop, windowWidth;
        windowWidth = document.documentElement.clientWidth;

        if (windowWidth < 768) return;

        const logoLocanda = document.querySelector("#logo_locanda")
        const mainMenu = document.querySelector('#main-menu')
        const imgLocanda = document.querySelector('#img_locanda')
        
        //console.log(windowWidth);
        
        stickyTop = window.scrollY
        relativeTopPosition = imgLocanda.getBoundingClientRect().top + stickyTop
        a = stickyTop / relativeTopPosition * 10
        b = 12 - a

        if (b > 0 && !mainMenu.classList.contains('open')) {
            logoLocanda.style.cssText = 'bottom: ' + b + 'rem'
        }
        
    }

}

export default Locanda;